// Module
var code = "<div class=\"container\"> <password-change submit-button=\"{{ $ctrl.passwordSubmitButton }}\" on-submit=\"$ctrl.confirmPasswordChange()\" confirm-uid=\"$ctrl.uid\" logout-button=\"true\"></password-change> </div> ";
// Exports
export default code;